// extracted by mini-css-extract-plugin
module.exports = {"Mosaic":"Mosaic_Mosaic__23QRu","Tile":"Mosaic_Tile__sUgto","Image":"Mosaic_Image__3IAim","Caption":"Mosaic_Caption__224pe","Clickable":"Mosaic_Clickable__2K8jv"};